import * as ProjectService from '@/services/project';
import { find, findIndex } from 'lodash';

export default {
  namespaced: true,

  state: {
    all: [],
    filter: {}
  },

  getters: {
    projects: state => state.all,

    GET_PROJECT_BY_ID: state => id => {
      return find(state.all, { id: id });
    }
  },

  mutations: {
    SET_FILTERS(state, payload) {
      state.filter = payload;
    },

    SET_PROJECTS(state, payload) {
      state.all = payload.projects;
    },

    SET_PROJECT(state, payload) {
      const index = findIndex(state.all, project => {
        return project.id === payload.id;
      });

      if (index !== -1) {
        state.all[index] = payload;
      } else {
        state.all.push(payload);
      }
    }
  },

  actions: {
    DELETE_PROJECT({ commit, state }, payload) {
      return ProjectService.deleteProject(payload.id)
        .then(response => {
          const index = findIndex(state.all, project => {
            return project.id === payload.id;
          });

          state.all.splice(index, 1);

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    GET_PROJECTS({ commit, state }) {
      return ProjectService.getProjects(state.filter)
        .then(response => {
          if (response.data) {
            commit('SET_PROJECTS', { projects: response.data });
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    },

    GET_PROJECT_BY_ID({ commit }, payload) {
      return ProjectService.getProject(payload.id)
        .then(response => {
          if (response.data) {
            commit('SET_PROJECT', response.data);
          }

          return response;
        })
        .catch(err => {
          return err;
        });
    }
  }
};
